/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPartyInfo,
    JsonPartyInfoFromJSON,
    JsonPartyInfoFromJSONTyped,
    JsonPartyInfoToJSON,
} from './JsonPartyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonPartyInfo
 */
export interface ApiResultOfJsonPartyInfo {
    /**
     * 
     * @type {JsonPartyInfo}
     * @memberof ApiResultOfJsonPartyInfo
     */
    data?: JsonPartyInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPartyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonPartyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPartyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPartyInfo
     */
    result?: ApiResultOfJsonPartyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonPartyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonPartyInfoFromJSON(json: any): ApiResultOfJsonPartyInfo {
    return ApiResultOfJsonPartyInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonPartyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonPartyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonPartyInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonPartyInfoToJSON(value?: ApiResultOfJsonPartyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonPartyInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

